import { createShortageProductsListKey } from 'constants/queryCacheKeys';
import { getShortageProductList, ShortageProductsListParams } from 'domain/stocks';
import { useQuery } from 'react-query';

export const useShortageList = (params: ShortageProductsListParams) => {
  return useQuery(createShortageProductsListKey(params), () => getShortageProductList(params));
};
